import { render } from "./ProductGuideSection.vue?vue&type=template&id=2bf1366f"
import script from "./ProductGuideSection.vue?vue&type=script&lang=js"
export * from "./ProductGuideSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__